/* File: auth.jsx
 * Path: ananunadm/src/helpers/auth.jsx
*/
import { useContext, createContext } from "react";

export const isLoggedIn = createContext();

export function useAuth() {
	return useContext(isLoggedIn);
}
